export const customerFilter = [
  {
    id: 1,
    title: "Tên khách hàng",
    value: "fullName",
  },
  {
    id: 2,
    title: "Tên ngắn",
    value: "sortName",
  },
  {
    id: 3,
    title: "Email",
    value: "email",
  },
  {
    id: 4,
    title: "Số điện thoại",
    value: "phone",
  },
  {
    id: 5,
    title: "Sale",
    value: "sale",
  },
  {
    id: 6,
    title: "Sale và KH",
    value: "saleAndClient",
  },
];
